export const constant = {
  MAP_API_KEY: 'AIzaSyA_3oXquRNt72TJqJl-UluBfoKvQQqPQ_I',
  INITIAL_LATITUDE_LONGITUDE: {
    lat: -6.612113,
    lng: 144.271163,
  },
  roleIsFor: ['Organization', 'External User'],
  toUse: ['Application', 'Project'],
  appAccess: ['dashboard', 'masters', 'userManagement', 'roleManagement', 'project', 'report'],
  projectAccess: [
    'detail',
    'teams',
    'milestones',
    'tasks',
    'payment',
    'reports',
    'closure',
    'files',
  ],
  APP_ACCESS: {
    dashboard: {
      fullAccess: false,
    },
    masters: {
      read: false,
      createOrUpdate: false,
      delete: false,
    },
    userManagement: {
      read: false,
      createOrUpdate: false,
      delete: false,
    },
    roleManagement: {
      read: false,
      createOrUpdate: false,
      delete: false,
    },
    project: {
      read: false,
      create: false,
      update: false,
      delete: false,
    },
    report: {
      read: false,
    },
  },
  PROJECT_ACCESS: {
    detail: {
      read: false,
      update: false,
    },
    teams: {
      read: false,
      assign: false,
      delete: false,
    },
    milestones: {
      read: false,
      createOrUpdate: false,
      delete: false,
    },
    tasks: {
      read: false,
      createOrUpdate: false,
      delete: false,
      verify: false,
    },
    payment: {
      read: false,
      createOrUpdate: false,
      delete: false,
      attachAndComment: false,
    },
    reports: {
      read: false,
    },
    closure: {
      read: false,
      commentAndClose: false,
      organizationComment: false,
      secretaryApproval: false,
    },
    files: {
      access: false,
    },
  },
  PROJECT_CATEGORY: [
    'Nationwide Project',
    'Province Project',
    'District Project',
    'School Project',
  ],
  SCHOOL_TYPE: ['System', 'Permitted'],
  PROJECT_PRIORITY: ['Low', 'Medium', 'High'],
  PROJECT_STATUS: [
    'Not Started',
    'In progress',
    'On Hold',
    'Completed',
    'Finished',
    'Cancelled',
    'Blocked',
    'Deferred',
    'Rejected',
  ],
  PAYMENT_MODE: ['One off Payment', 'Progressive Payments'],
  file_from: {
    project: 'project',
    milestone: 'milestone',
    task: 'task',
    payment: 'payment',
    closure: 'closure',
    confidential: 'confidential',
  },
}
